var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{staticClass:"d-md-down-none",on:{"click":_vm.toggle}},[_c('i',{staticClass:"icon-frame"})])}]

export { render, staticRenderFns }